import { render, staticRenderFns } from "./FishInfoTab.vue?vue&type=template&id=3afe6463&"
import script from "./FishInfoTab.vue?vue&type=script&lang=ts&"
export * from "./FishInfoTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports